import { render, staticRenderFns } from "./AncillaryMemberCard.vue?vue&type=template&id=fc52beb2"
import script from "./AncillaryMemberCard.vue?vue&type=script&lang=js"
export * from "./AncillaryMemberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports